var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoErrorCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6A6.6 6.6 0 108 1.4a6.6 6.6 0 000 13.2z",
    fill: "#fff",
    stroke: "#F74F4F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 9.5V4h1.5v5.5h-1.5zM7.25 12v-1.5h1.5V12h-1.5z",
    fill: "#F74F4F"
  })));
}
export default __webpack_public_path__ + "static/info-error-circle-outline.6dadb1fd.svg";
export { SvgInfoErrorCircleOutline as ReactComponent };